module.exports = __webpack_public_path__ + "img/nothing.7bc7fb91.png";